module.exports = __webpack_public_path__ + "static/media/mask1.298ef1da.png";